import ExcelJS from 'exceljs';

export class DownloadExcelHelpers {

	constructor() {
		this.baseURLAPI = "";
	}

	async serverDownloadTextFile(url) {
		
		var responseText = "";
		
		try {
			var res = await fetch(url);
			responseText = await res.text();
		} catch (err) {
			console.error(err);
		}

		return responseText;
	}
	
	separateTextIntoArrayOfLines(inputText) {

		var lineArray = [];

		if (inputText === null) {
			inputText = "";
		}

		if (inputText === "") {
			return lineArray;
		}

		var i;
		var ch;
		var len = inputText.length;
		var oneLineText = "";
		
		for(i=0; i<len; i++) {
			ch = inputText[i];
			if (ch === "\n") {
				lineArray.push(oneLineText);
				oneLineText = "";
			} else {
				if (ch !== "\r") {
					oneLineText = oneLineText + ch;
				}
			}
		}
		
		lineArray.push(oneLineText);

		return lineArray;
	}

	extractJsonString(string1) {
		
		string1 = string1.trim();
		if (string1 === "") {
			return "";
		}
		
		var startTag = '```json';
		var endTag = '```';

		const startIndex = string1.indexOf(startTag);
		if (startIndex === -1) {
			return "";
		}

		const endIndex = string1.indexOf(endTag, startIndex + startTag.length);
		if (endIndex === -1) {
			return "";
		}
		
		var jsonString = string1.substring(startIndex + startTag.length, endIndex).trim();
		return jsonString;
	}
	
	async serverStorageProxy(storageID, filename) {
		
		var baseURLAPI = this.baseURLAPI;
		var url = baseURLAPI + "/storageproxy?storageid=" + encodeURIComponent(storageID);
		url = url + "&filename=" + encodeURIComponent(filename);

		var responseText = "";
		
		try {
			var res = await fetch(url);
			responseText = await res.text();
		} catch (err) {
			console.error(err);
		}

		return responseText;
	}
		
	async processOneSource(notebookJsonObj, itemObj) {

		var notebookStorageID = notebookJsonObj.storageID;
		var filenameExt = itemObj.filename;

		var filename = filenameExt.substring(0, filenameExt.lastIndexOf('.'));
		var filenameOut = filename + ".out";
		var outText = await this.serverStorageProxy(notebookStorageID, filenameOut);
		var jsonString = this.extractJsonString(outText);

		var jsonObj = null;
		
		if (jsonString !== "") {
			try {
				jsonObj = JSON.parse(jsonString);
			} catch (err) {
				console.error(err);
			}
		}
		
		if (jsonObj !== null) {
			if (Array.isArray(jsonObj)) {
				if (jsonObj.length === 1) {
					jsonObj = jsonObj[0];
				}
			}
		}
		
		return [outText, jsonObj];
	}
	
	async processAllSources(notebookJsonObj, sourceArray) {
		
		var i;
		var j;
		var itemObj;
		var outText;
		var jsonObj;
		var jsonObj2;
		var outTextArray = [];
		var jsonArray = [];
		
		for(i=0; i<sourceArray.length; i++) {
			itemObj = sourceArray[i];
			[outText, jsonObj] = await this.processOneSource(notebookJsonObj, itemObj);
			outTextArray.push(outText);
			if (jsonObj !== null) {
				if (Array.isArray(jsonObj)) {
					for(j=0; j<jsonObj.length; j++) {
						jsonObj2 = jsonObj[j];
						jsonArray.push(jsonObj2);
					}
				} else {
					jsonArray.push(jsonObj);
				}
			}
		}
		
		return [outTextArray, jsonArray];
	}
	
	isNumeric(str) {
		return !isNaN(str) && !isNaN(parseFloat(str));
	}

	getItemFromKey(array1, key1) {
		
		var i;
		var itemObj;
		var key2;
		
		for(i=0; i<array1.length; i++) {
			itemObj = array1[i];
			key2 = itemObj.key;
			if (key1 === key2) {
				return itemObj;
			}
		}
		
		return null;
	}

	getFieldArray(jsonArray) {
		
		var i;
		var jsonObj;
		var itemObj;
		var key;
		var value;
		var itemType;
		var foundYN;
		var fieldArray = [];

		for(i=0; i<jsonArray.length; i++) {
			
			jsonObj = jsonArray[i];

			for (key in jsonObj) {
				if (jsonObj.hasOwnProperty(key)) {
					value = jsonObj[key];
					if (this.getItemFromKey(fieldArray, key) === null) {
						foundYN = false;
					} else {
						foundYN = true;
					}
					if (!foundYN) {
						itemType = "string";
						if (Array.isArray(value)) {
							itemType = "array";
						} else {
							if (this.isNumeric(value)) {
								itemType = "number";
							}
						}
						itemObj = {};
						itemObj.key = key;
						itemObj.type = itemType;
						fieldArray.push(itemObj);
					}
				}
			}	
		}

		return fieldArray;
	}
	
	getExcelColumnLetter(index) {
		var letter = String.fromCharCode(65 + index);
		return letter;
	}
	
	async createExcel(notebookJsonObj, sourceArray) {
		
		var outTextArray;
		var jsonArray;

		// process all sources
		[outTextArray, jsonArray] = await this.processAllSources(notebookJsonObj, sourceArray);
		
		// create excel

		var cellRef;
		var cellObj;
		var workbook = new ExcelJS.Workbook();

		var worksheet1 = workbook.addWorksheet("Analysis");

		var i;
		var j;
		var key;
		var value;
		var itemObj;
		var itemType;
		var jsonObj;
		var fieldArray = this.getFieldArray(jsonArray);
		var length = fieldArray.length;
		var row = 1;
		
		if (length > 28) {
			length = 28;
		}
		
		for(i=0; i<length; i++) {

			itemObj = fieldArray[i];
			key = itemObj.key;
			itemType = itemObj.itemType;

			cellRef = this.getExcelColumnLetter(i) + row;
			cellObj = worksheet1.getCell(cellRef);
			cellObj.font = { 
				bold: true,
				color: { argb: '0000FF' },
			};	
			cellObj.value = key;

			if (itemType === "number") {
				cellObj.alignment = { horizontal: 'right' };
			}
		}
		row ++;
		
		for(i=0; i<jsonArray.length; i++) {

			jsonObj = jsonArray[i];

			for(j=0; j<fieldArray.length; j++) {
				itemObj = fieldArray[j];
				key = itemObj.key;
				itemType = itemObj.itemType;
				cellRef = this.getExcelColumnLetter(j) + row;
				cellObj = worksheet1.getCell(cellRef);
				if (jsonObj.hasOwnProperty(key)) {
					value = jsonObj[key];
					if (itemType === "array") {
						cellObj.value = value;
					} else {
						cellObj.value = value;
						if (itemType === "number") {
							cellObj.alignment = { horizontal: 'right' };
						}
					}
				}
			}
			row ++;
		}

		// auto-adjust column widths
		worksheet1.columns.forEach(column => {
			let maxLength = 10;
			column.eachCell({ includeEmpty: true }, cell => {
				const columnLength = cell.value ? cell.value.toString().length : 0;
				if (columnLength > maxLength) {
					maxLength = columnLength;
				}
			});
			column.width = maxLength + 2;
		});

		var filenameExt;
		var filename;
		var outText;
		var outTextLines;
		var oneLine;
		var worksheet2;

		for(i=0; i<sourceArray.length; i++) {

			itemObj = sourceArray[i];
			outText = outTextArray[i];
			filenameExt = itemObj.filename;
			filename = filenameExt.substring(0, filenameExt.lastIndexOf('.'));

			outTextLines = this.separateTextIntoArrayOfLines(outText);

			worksheet2 = workbook.addWorksheet(filename);

			worksheet2.columns = [
				{ key: 'A', width: 1000 },
			];

			cellObj = worksheet2.getCell("A1");
			cellObj.font = { 
				bold: true,
				color: { argb: '0000FF' },
			};	
			cellObj.value = filename.toUpperCase();
			
			for(j=0; j<outTextLines.length; j++) {
				cellObj = worksheet2.getCell("A" + (j+3));
				oneLine = outTextLines[j];
				cellObj.value = oneLine;
			}
		}

		var excelBuffer = await workbook.xlsx.writeBuffer();				
		return excelBuffer;
	}
}
